import {isPlatformBrowser, NgOptimizedImage} from "@angular/common";
import type {AfterViewInit, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {Component, inject, input, PLATFORM_ID, viewChild} from "@angular/core";
import {RouterLink, RouterLinkActive} from "@angular/router";

interface MenuItem {
  readonly label: string;
  readonly routerLink: string;
}

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.html",
  styleUrl: "./navbar.scss",
  imports: [
    RouterLink,
    RouterLinkActive,
    NgOptimizedImage,
  ],
})
export class Navbar implements OnInit, AfterViewInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);

  public readonly isHome = input<boolean>(false);

  protected readonly navbarLogo = viewChild.required<ElementRef<HTMLElement>>("navbarLogo");
  private intersectionObserver: IntersectionObserver | null = null;

  protected readonly items: readonly MenuItem[] = [
    {
      label: $localize`Home`,
      routerLink: "/",
    },
    {
      label: $localize`News`,
      routerLink: "/news",
    },
    {
      label: $localize`Dienstleistungen`,
      routerLink: "/services",
    },
    {
      label: $localize`Projekte`,
      routerLink: "/projects",
    },
    {
      label: $localize`Über uns`,
      routerLink: "/about-us",
    },
    {
      label: $localize`Kontakt`,
      routerLink: "/contact",
    },
  ];

  public ngOnInit(): void {
    if (this.isHome() && isPlatformBrowser(this.platformId)) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          entry.target.classList.toggle("fade-in", entry.boundingClientRect.top <= 1);
        }
      }, {
        rootMargin: "-2px 0px 0px 0px",
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        threshold: Array.from({length: 201}, (_, idx) => 0.8 + idx / 1000),
      });
    }
  }

  public ngAfterViewInit(): void {
    this.intersectionObserver?.observe(this.navbarLogo().nativeElement);
  }

  public ngOnDestroy(): void {
    this.intersectionObserver?.disconnect();
    this.intersectionObserver = null;
  }
}
